<template>
  <section>
    <div
      class="login-form"
      v-loading.fullscreen.lock="configureLoading"
      :element-loading-text="LoadingText"
      element-loading-spinner="el-icon-loading"
      element-loading-background="rgba(0, 0, 0, 0.8)"
    >
      <div>
        <div class="d-flex justify-between align-center mb-3 flex-wrap">
          <span class="register-heading" :style="getPrimaryColor">Complete Your Profile!</span>
        </div>
        <div class="divider">
          <span class="line"></span>
          <span class="line"></span>
        </div>
        <div class="content">
          <div>
            <el-form
              :model="signup"
              :rules="rules"
              ref="signup"
              class="log-form"
              @keyup.enter.native="submitForm('signup')"
            >
              Please complete your profile {{ signup.email }} associated with
              {{ signup.company_name }}!
              <div class="d-flex">
                <el-form-item label="First Name" prop="first_name" class="mr-1">
                  <el-input v-model="signup.first_name" placeholder="Enter first name"></el-input>
                  <p class="error" v-if="getErrors && getErrors.first_name">
                    {{ getErrors.first_name }}
                  </p>
                </el-form-item>
                <el-form-item label="Last Name" prop="last_name">
                  <el-input v-model="signup.last_name" placeholder="Enter last name"></el-input>
                  <p class="error" v-if="getErrors && getErrors.last_name">
                    {{ getErrors.last_name }}
                  </p>
                </el-form-item>
              </div>
              <el-form-item label="Mobile" prop="phone">
                <el-input
                  type="number"
                  v-model="signup.phone"
                  placeholder="989 989 9899"
                  autocomplete="off"
                ></el-input>
                <p class="error" v-if="getErrors && getErrors.phone">
                  {{ getErrors.phone }}
                </p>
              </el-form-item>
              <el-form-item label="Password" class="mb-1" prop="password">
                <el-input
                  :type="passwordType"
                  placeholder="Enter Password"
                  v-model="signup.password"
                  autocomplete="off"
                  ref="passwordInput"
                  @input="checkPassword"
                >
                  <template slot="suffix">
                    <i
                      :class="passwordType === 'password' ? 'fa fa-eye' : 'fa fa-eye-slash'"
                      @click="passwordType = passwordType === 'password' ? 'text' : 'password'"
                      style="cursor: pointer; padding-right: 10px"
                    ></i>
                  </template>
                </el-input>
                <p class="error" v-if="getErrors && getErrors.password">
                  {{ getErrors.password }}
                </p>
                <p class="error" v-if="errors && errors.password">
                  {{ errors.password }}
                </p>
              </el-form-item>

              <el-form-item label="Confirm Password" class="mb-1" prop="cPassword">
                <el-input
                  :type="confirm_password_type"
                  placeholder="Confirm Password"
                  v-model="signup.cPassword"
                  autocomplete="off"
                  ref="passwordInput"
                  @input="checkConfirmPassword"
                >
                  <template slot="suffix">
                    <i
                      :class="
                        confirm_password_type === 'password' ? 'fa fa-eye' : 'fa fa-eye-slash'
                      "
                      @click="
                        confirm_password_type =
                          confirm_password_type === 'password' ? 'text' : 'password'
                      "
                      style="cursor: pointer; padding-right: 10px"
                    ></i>
                  </template>
                </el-input>
              </el-form-item>

              <span class="error" v-for="(err, index) in passwordError" :key="index">
                {{ err }}
                <br />
              </span>
              <el-form-item prop="terms_and_conditions">
                <el-checkbox
                  name="terms_and_conditions"
                  v-model="signup.terms_and_conditions"
                  @change="handleTermsState"
                >
                  I agree
                  <el-link type="primary" :underline="false" @click="displayTermsAndConditions">
                    Terms
                  </el-link>
                  &
                  <el-link type="primary" :underline="false" @click="displayPrivacyPolicy">
                    Conditions
                  </el-link>
                </el-checkbox>
                <p class="error" v-if="errors.terms_and_conditions">
                  You have to agree the terms and privacy condition.
                </p>
              </el-form-item>
              <el-form-item class="mt-1">
                <el-button
                  type="primary"
                  class="type-2 w-100 fs-6 bg-color"
                  @click="submitForm('signup')"
                  :loading="submitLoading"
                >
                  Update Profile
                </el-button>
                <p
                  class="error"
                  v-if="
                    getErrors &&
                    getErrors.critical_error &&
                    getErrors.critical_error != 'Account with this email is already taken'
                  "
                >
                  {{ getErrors.critical_error }}
                </p>
              </el-form-item>
            </el-form>
          </div>
        </div>
      </div>
    </div>

    <el-dialog
      :visible.sync="terms_and_conditions_dialog"
      :title="isTermsConditionsActive ? 'Terms and Conditions' : 'Privacy Policy'"
      class="terms-conditions-dilalog-main"
      :before-close="resetTermsAndPrivacy"
    >
      <div>
        <div style="padding: 5px" v-if="isTermsConditionsActive">
          <termsAndConditionsTemplate />
        </div>
        <div style="padding: 5px" v-else>
          <privacyAndPolicyTemplate />
        </div>
      </div>
    </el-dialog>
  </section>
</template>
<script>
  import WhiteLabelConfig from '../../config/app';
  import { mapGetters } from 'vuex';
  import termsAndConditionsTemplate from '@/components/templates/termsAndConditionsTemplate.vue';
  import privacyAndPolicyTemplate from '@/components/templates/privacyAndPolicyTemplate.vue';
  import Swal from 'sweetalert2';

  import moment from 'moment';
  export default {
    name: 'InviteUser',
    components: {
      termsAndConditionsTemplate,
      privacyAndPolicyTemplate,
    },
    data() {
      return {
        applicationSettings: {},
        userDetails: {},
        isPrivacyPolicyActive: false,
        terms_and_conditions_dialog: false,
        isTermsConditionsActive: false,
        passwordError: [],
        submitLoading: false,
        passwordType: 'password',
        confirm_password_type: 'password',
        signup: {
          first_name: '',
          last_name: '',
          company_name: '',
          email: '',
          password: '',
          // terms_and_conditions: false,
          phone: '',
          cPassword: '',
        },
        password_rules: [
          {
            message:
              'Must have one Uppercase(A-Z) letter,one lowercase(a-z) letter ,one number(0-9) and one symbol',
            regex: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[#$@!%&*?])[A-Za-z\d#$@!%&*?]{8,30}$/,
          },
        ],
        rules: {
          // email: [
          //   {
          //     required: true,
          //     message: 'Email is required',
          //     trigger: 'blur',
          //   },
          //   {
          //     type: 'email',
          //     message: 'Invalid Email',
          //     trigger: 'blur',
          //   },
          // ],
          password: [
            // {
            //   required: true,
            //   message: "Password is required",
            //   trigger: "blur",
            // },
            // { validator: validatePass, trigger: "blur" },
          ],
          cPassword: [
            // {
            //   required: true,
            //   message: "Password is required",
            //   trigger: "blur",
            // },
            // { validator: validatePass2, trigger: "blur" },
          ],
          phone: [
            {
              required: true,
              message: 'Phone is required',
              trigger: 'blur',
            },
            {
              required: true,
              // pattern: /^[+]?[(]?[0-9]{3}[)]?[-\s.]?[0-9]{3}[-\s.]?[0-9]{4,6}$/im,
              pattern: /^\(?(\d{3})\)?[- ]?(\d{3})[- ]?(\d{4})$/,
              message: 'Invalid Phone Number',
            },
          ],
          first_name: [
            {
              required: true,
              message: 'First name is required',
              trigger: 'blur',
            },
          ],
          last_name: [
            {
              required: true,
              message: 'Last name is required',
              trigger: 'blur',
            },
          ],
          // company_name: [
          //   {
          //     required: true,
          //     message: 'Company name is required',
          //     trigger: 'blur',
          //   },
          // ],
        },
        errors: {},
      };
    },
    mounted() {
      this.applicationSettings = WhiteLabelConfig;
      this.resetStore();
      this.getInviteUserDetails();
    },
    computed: {
      ...mapGetters('errors', ['getErrors']),
      ...mapGetters('auth', [
        'getAuthenticationStatus',
        'isSignupCompleted',
        'getAccountNotVerified',
        'getAccountNotVerifiedEmail',
        'getAddCompanyUser',
        'getSignupStatus',
      ]),
    },
    created() {
      this.resetStore();
      this.$store.commit('errors/setErrors', null, { root: true });
    },
    methods: {
      handleTermsState() {
        this.errors.terms_and_conditions = this.signup.terms_and_conditions ? false : true;
      },
      resetStore() {
        this.$store.commit('auth/resetAuthData', null, { root: true });
        this.$store.commit('configurableDocuments/resetConfigurableDocuments', null, {
          root: true,
        });
        this.$store.commit('employeeData/reset', null, { root: true });
        this.$store.commit('employeeDocuments/reset', null, { root: true });
        // this.$store.commit("employeeDocumentAuthorizedUsers/reset");
      },
      checkPassword() {
        this.errors.password = '';
        this.passwordError = [];
        if (this.signup.password) {
          this.password_rules.forEach((rule) => {
            if (!rule.regex.test(this.signup.password)) {
              this.passwordError.push(rule.message);
            }
          });
          if (this.signup.password.length && this.signup.cPassword.length) {
            // this.checkConfirmPassword();
            if (this.signup.password != this.signup.cPassword) {
              this.passwordError.push('Password miss match');
            }
          }
        } else {
          {
            this.errors.password = 'Password is required';
          }
        }
      },
      checkConfirmPassword() {
        this.passwordError = [];
        // if (this.passwordError.length && this.signup.cPassword.length) {
        if (this.signup.password != this.signup.cPassword) {
          this.passwordError.push('Password miss match');
        } else {
          this.passwordError = [];
        }
      },
      submitForm(formName) {
        this.errors = {};
        this.checkPassword();
        if (!this.signup.cPassword.length && this.signup.password != this.signup.cPassword) {
          this.passwordError.push('Password miss match');
        }
        this.$refs[formName].validate((valid, errors) => {
          if (valid) {
            if ((this.errors && this.errors.password) || this.passwordError.length) {
              return false;
            } else if (!this.signup.terms_and_conditions) {
              {
                this.errors.terms_and_conditions = true;
                return false;
              }
            } else {
              this.signUp();
            }
          } else {
            console.log('Error in submit Form', errors);
            return false;
          }
        });
      },
      resetForm(formName) {
        this.$refs[formName].resetFields();
      },
      resetTermsAndPrivacy() {
        this.isTermsConditionsActive = false;
        this.terms_and_conditions_dialog = false;
      },
      displayTermsAndConditions() {
        this.isTermsConditionsActive = true;
        this.terms_and_conditions_dialog = true;
      },
      displayPrivacyPolicy() {
        this.terms_and_conditions_dialog = true;
      },
      async signUp() {
        try {
          this.submitLoading = true;
          let companyId = this.$route.query.company;
          let wIndex = this.userDetails.user.workspace.findIndex(
            (w) => w.company_id.toString() == companyId.toString()
          );
          let cWorkspace = this.userDetails.user.workspace[wIndex];
          if (cWorkspace.status != 'ACTIVE' || cWorkspace.email_confirmed == false) {
            let data = {
              _id: this.userDetails.user._id,
              company_id: this.userDetails.company._id,
              first_name: this.signup.first_name,
              last_name: this.signup.last_name,
              email: this.signup.email.toLowerCase(),
              password: this.signup.password,
              terms_and_conditions: this.signup.terms_and_conditions,
              phone: this.signup.phone,
              account_status: true,
            };
            await this.$store.dispatch('auth/inviteUserSignup', data);
            if (this.isSignupCompleted) {
              this.$notify.success({
                title: 'Success',
                message: 'Registered Successfully',
              });
              this.$router.push('/signin');
            }
          } else {
            Swal.fire({
              icon: 'info',
              title: '',
              text: "You can't have a permission to update your profile using this link.Please login and update your Profile",
              allowOutsideClick: false,
              allowEscapeKey: false,
              allowEnterKey: false,
              confirmButtonText: 'Login',
            }).then((result) => {
              if (result.isConfirmed) {
                //api call
                Swal.close();
                let timerInterval;
                Swal.fire({
                  title: '',
                  html: 'Please wait ..... We are redirecting to login page',
                  timer: 2000,
                  allowOutsideClick: false,
                  allowEscapeKey: false,
                  allowEnterKey: false,
                  didOpen: () => {
                    Swal.showLoading();
                  },
                  willClose: () => {
                    this.$router.push('/signin');
                    clearInterval(timerInterval);
                  },
                });
              }
            });
          }
          this.submitLoading = false;
        } catch (err) {
          this.submitLoading = false;
          console.log('signUp', err);
        }
      },
      async getInviteUserDetails() {
        if (this.$route.query.access) {
          // let bytes = await this.$CryptoJS.AES.decrypt(this.$route.query.access, 'secret key 123');
          // let decryptedData = JSON.parse(bytes.toString(this.$CryptoJS.enc.Utf8));
          // let beginningTime = moment.utc(moment().format());
          // let endTime = moment.utc(decryptedData.exp);
          console.log(moment.utc(moment().format())); // true
          // if(beginningTime.isBefore(endTime))
          // {
          //   //valid
          //   console.log("Link valid");
          // }
          // else{
          //   console.log("Link Expired");
          // }
        }

        let params = {
          userId: this.$route.query.email,
          companyId: this.$route.query.company,
        };
        await this.$store.dispatch('auth/getInviteUser', params);
        if (this.getAddCompanyUser) {
          this.userDetails = this.getAddCompanyUser;
          this.signup = this.userDetails.user;
          this.signup.email = params.userId;
          this.signup.company_name = this.userDetails.company.name;
          this.signup.password = '';
          this.signup.cPassword = '';
          this.signup.terms_and_conditions = false;
        }
      },
    },
  };
</script>
<style lang="scss">
  .swal2-icon {
    .swal2-info {
      border-color: #f754a2 !important;
      color: #f754a2 !important;
    }
  }

  .swal2-styled {
    .swal2-confirm {
      background-color: #f754a2 !important;
    }
  }

  .has-error {
    border-color: red;
  }

  a {
    text-decoration: none !important;
    color: #196392 !important;
  }

  a:hover {
    text-decoration: underline !important;
    /* Optional: underline on hover */
    color: #196392 !important;
  }

  .divider {
    display: flex;
    align-items: center;
    width: 100%;
    text-align: center;
    /* margin: 0 20px; */
  }

  .line {
    flex: 1;
    border-top: 1px solid #ddd;
    /* light gray line */
  }

  .password-input-wrapper {
    position: relative;
  }

  .password-toggle {
    position: absolute;
    right: 10px;
    top: 50%;
    transform: translateY(-50%);
    color: #409eff;
    cursor: pointer;
    font-size: 13px;
    font-weight: 500;
    user-select: none;
  }

  .login-form {
    border: 1px solid #cfcfcf;
    border-radius: 2em;
    width: 100%;
    max-width: 550px;
    padding: 2rem;
    /* border-radius: 8px; */
    background: #fff;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    box-sizing: border-box;
  }

  .login-form h2 {
    margin-bottom: 1.5rem;
    color: #333;
    text-align: center;
  }

  .login-form input {
    width: 100%;
    padding: 0.75rem;
    margin-bottom: 1rem;
    border: 1px solid #ccc;
    border-radius: 4px;
    box-sizing: border-box;
  }

  /* FULL RESPONSIVE FOR MOBILE & TABLET */
  @media (max-width: 1024px) {
    .login-form {
      border: 1px solid #cfcfcf;
      border-radius: 2em;
      // max-width: 100%;
      padding: 1.5rem;
      margin: 0 auto;
      box-shadow: none;
      /* border-radius: 0; */
    }

    .login-form h2 {
      font-size: 1.5rem;
    }

    .password-toggle {
      right: 10px;
      font-size: 12px;
    }
  }

  .el-form-item {
    margin-bottom: 8px !important;
  }

  .name-fields {
    display: flex;
    flex-direction: column;
    gap: 10px;
  }

  @media (min-width: 768px) {
    .name-fields {
      flex-direction: row;
    }

    .name-fields .el-form-item {
      flex: 1;
    }

    .name-fields .el-form-item:first-child {
      margin-right: 10px;
    }
  }

  .terms-wrap {
    display: inline-block;
    white-space: normal;
    word-break: break-word;
    max-width: 100%;
  }

  .d-flex {
    display: flex;
  }

  .justify-between {
    justify-content: space-between;
  }

  .align-center {
    align-items: center;
  }

  .flex-wrap {
    flex-wrap: wrap;
  }

  .mb-3 {
    margin-bottom: 1rem;
  }

  .m-0 {
    margin: 0;
  }

  .register-heading {
    font-size: 1.25rem;
    font-weight: 600;
    color: #196392;
    padding-bottom: 0.5rem;
    margin: 0;
    display: inline-block;
  }
</style>
